import {httpCore} from "./instance/http";

export const postWebhook    = params => httpCore.post('callme/rest/send-webhook',params);

